import { useContext, useEffect } from "react";

import { useLazyQuery } from "@apollo/client";
import get from "lodash/get";
import { INFO, COMMON_INFO, CUSTOMER_INFO } from "shared/graphql/queries";
import { StoreContext } from "shared/store";

export const useInfo = () => {
  const {
    setInfo,
    info,
    setCommonInfo,
    commonInfo,
    setCustomerInfo,
    customerInfo,
  } = useContext(StoreContext);
  const [getInfo, queryInfo] = useLazyQuery(INFO);
  const [getCommonInfo, queryCommonInfo] = useLazyQuery(COMMON_INFO);
  const [getCustomerInfo, queryCostumerInfo] = useLazyQuery(CUSTOMER_INFO);

  useEffect(() => {
    queryInfo.data && setInfo(get(queryInfo, "data.info", {}));
  }, [queryInfo.data]);

  useEffect(() => {
    queryCostumerInfo.data &&
      setCustomerInfo(get(queryCostumerInfo, "data.customerInfo", {}));
  }, [queryCostumerInfo.data]);

  useEffect(() => {
    if (queryCommonInfo.data) {
      const _data = get(queryCommonInfo, "data.commonInfo", {});
      setCommonInfo(_data);
      _data.knownCustomer && getCustomerInfo();
    }
  }, [queryCommonInfo.data]);

  return {
    getCustomerInfo,
    getCommonInfo,
    getInfo,
    info,
    commonInfo,
    customerInfo,
  };
};
